var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-wrapper" }, [
    _c(
      "div",
      { staticClass: "header_left" },
      [
        _c("img", {
          attrs: {
            src: require("../../../../static/images/newRealTask/zljy-logo.png"),
            alt: ""
          },
          on: {
            click: function($event) {
              return _vm.$router.push("/Home")
            }
          }
        }),
        _vm._v(" "),
        _vm.flag == 2
          ? _c(
              "el-button",
              { staticClass: "goback", on: { click: _vm.myfuntion } },
              [
                _c("i", { staticClass: "el-icon-arrow-left" }),
                _vm._v("公司与项目")
              ]
            )
          : _vm.flag == 1
          ? _c(
              "p",
              {
                on: {
                  click: function($event) {
                    return _vm.$router.push("/Home")
                  }
                }
              },
              [
                _c("i", { staticClass: "el-icon-sort" }),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.prodName ? _vm.prodName : _vm.deptName) +
                    "\n    "
                )
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "header_right" }, [
      _c(
        "div",
        { staticClass: "login-user" },
        [
          _c(
            "el-dropdown",
            {
              attrs: { "show-timeout": 0 },
              on: { command: _vm.handleCommand }
            },
            [
              _c("div", { staticClass: "user-name el-dropdown-link" }, [
                _c("div", { staticClass: "imgBox" }, [
                  _c("img", { attrs: { src: _vm.imgUrl } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "login-name" }, [
                  _vm._v(_vm._s(_vm.name))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "d" } }, [
                    _vm._v("退出")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e79536c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e79536c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newRealTask/components/newRealyObjectHeader.vue
// module id = null
// module chunks = 